module.exports = __webpack_public_path__ + "img/circle-3.2.0bc75056.svg";